module.exports = __webpack_public_path__ + "static/media/burger.76a839b5.png";